import React, {  } from 'react';
import styled from 'styled-components/macro';

import { P } from '../../../components/Typography';
import { distances, colors } from '../../../styles/constants';
import { Button } from '../../../components/Buttons';

interface SmallMarketingButtonProps {
    text: string;
    onClick?: () => void;
}

const SmallMarketingButton = (
    {
        text,
        onClick,
    }: SmallMarketingButtonProps
) => (<>
    <AddNewListWrapper>
        <AddNewListButton type="button" onClick={onClick}>
            {'+'}
        </AddNewListButton>
        <P>{text}</P>
    </AddNewListWrapper>
</>);

const AddNewListWrapper = styled.div`
    display: flex;
    align-items: center;

    > *:first-child {
        margin-right: ${distances.small};
    }
`;

const AddNewListButton = styled(Button as any)`
    min-width: 0;
    min-height: 0;
    padding: 0;
    width: ${distances.normal};
    height: ${distances.normal};
    color: ${colors.background};
    background-color: ${colors.primary};
    border-color: ${colors.primary};

    &:hover {
        background-color: ${colors.primaryHover};
        border-color: ${colors.primaryHover};
    }
`;

export default SmallMarketingButton;
